import { Pipe, PipeTransform } from '@angular/core';
import { Trend, RawTrendData } from '../models/trend';
import { Port } from '../models/port';

@Pipe({name: 'trendMassage'})
export class TrendMassagePipe implements PipeTransform {
  transform(raw: RawTrendData[], port: Port, portType: number): Trend {
    let unit = '';
    if(port.rsm_port_ainput && port.rsm_port_ainput.port_display_unit){
      unit = `(${port.rsm_port_ainput.port_display_unit})`;
    }

    let base: Trend = {
        name: port.port_label + unit,
        series: []
      };

      //return empty data when there are no results
      if(!raw) {
        base.series.push({
          value: 0,
          name: 'No Results'
        });
        return base;
      };
      
      raw.forEach(element => {
        base.series.push({
          value: element.port_calc_value,
          name: new Date(element.trend_timestamp)
        });
      });
    return base;
  }
}

/* have this  */